import { render, staticRenderFns } from "./scxxDeatil.vue?vue&type=template&id=9aa1166e&scoped=true&"
import script from "./scxxDeatil.vue?vue&type=script&lang=js&"
export * from "./scxxDeatil.vue?vue&type=script&lang=js&"
import style0 from "./scxxDeatil.vue?vue&type=style&index=0&id=9aa1166e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa1166e",
  null
  
)

export default component.exports